import React from 'react';
import styled from 'styled-components';
import { Button } from '~/ui/buttons';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  width: 0px;

  button {
    z-index: 199;
    padding: 8px;
    padding-top: 20px;
    padding-bottom: 20px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    margin-left: 24px;
    &:hover {
      opacity: 1;
    }
  }
`;

export const CloseButton = ({
  showMenu,
  setShowMenu
}: {
  showMenu: boolean;
  setShowMenu: (value: boolean) => void;
}) => {
  return (
    <Wrapper>
      <Button onClick={() => setShowMenu(!showMenu)}>
        {showMenu ? '<' : '>'}
      </Button>
    </Wrapper>
  );
};
